import { render, staticRenderFns } from "./customNotice.vue?vue&type=template&id=5e32a245&scoped=true&"
import script from "./customNotice.vue?vue&type=script&lang=js&"
export * from "./customNotice.vue?vue&type=script&lang=js&"
import style0 from "./customNotice.vue?vue&type=style&index=0&id=5e32a245&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e32a245",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e32a245')) {
      api.createRecord('5e32a245', component.options)
    } else {
      api.reload('5e32a245', component.options)
    }
    module.hot.accept("./customNotice.vue?vue&type=template&id=5e32a245&scoped=true&", function () {
      api.rerender('5e32a245', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/insuredNotice/customNotice.vue"
export default component.exports